import { 
  init, 
  isInitialized,
  breadcrumbsIntegration,
  replayIntegration,
  reactRouterV6BrowserTracingIntegration
} from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router";
import React, { FC, PropsWithChildren } from 'react';
import { useSettingsContext } from '../Settings/hooks/useSettingsContext';

interface SentryProps extends PropsWithChildren {
}

const SentryProvider: FC<SentryProps> = ({
  children
}) => {
  const Settings = useSettingsContext();

  // Added ignore to Sentry console logs as they are unreadable and useless:
  // https://github.com/getsentry/sentry-react-native/issues/794#issuecomment-908189765

  if (
    Settings.sentry && Settings.sentry.dsn && !isInitialized()
  ) {
    init({
      dsn: Settings.sentry.dsn,
      
      environment: Settings.sentry.environment,

      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: Settings?.sentry?.sessionReplays?.errorSampleRate ?? 1.0,

      integrations: [
        breadcrumbsIntegration({
          console: false
        }),
        reactRouterV6BrowserTracingIntegration({
          useEffect: React.useEffect,
          useLocation,
          useNavigationType,
          createRoutesFromChildren,
          matchRoutes,
        }),
        ...(Settings?.sentry?.sessionReplays?.enabled ? [replayIntegration({
          maskAllText: false,
          maskAllInputs: false,
          blockAllMedia: false,
        })] : [])
      ]

    });
  }

  return children;
};

export default SentryProvider;
